<i18n>
{
  "fr": {
    "configuratorProductList": {
      "noItem": "Il n'y a pas de thèmes disponibles pour cette configuration (contenance/type d'impression)."
    }
  }
}
</i18n>

<template>
  <div
    :class="[BLOCK_SELECTOR, { [`${BLOCK_SELECTOR}--is-docked`]: isDocked }]"
  >
    <div v-if="items.length" :class="`${BLOCK_SELECTOR}__list-wrapper`">
      <ul :class="`${BLOCK_SELECTOR}__list`">
        <ConfiguratorProductItem
          v-for="item in items"
          :key="item.product.id"
          v-model="activeProductId"
          :class="`${BLOCK_SELECTOR}__item`"
          tag="li"
          :img-url="item.configuration.image || item.product.image"
          :label="item.product.name"
          :value="item.product.id"
          :size-id="item.productVariant.sizeId"
          name="product"
        />
      </ul>

      <div :class="`${BLOCK_SELECTOR}__theme-picker-button-wrapper`">
        <ConfiguratorEditorThemePickerButton
          :class="`${BLOCK_SELECTOR}__theme-picker-button`"
          @request-open-theme-picker-modal="
            $emit('request-open-theme-picker-modal')
          "
        />
      </div>
    </div>
    <div v-else>
      <p
        class="configurator-product-list__no-item"
        v-text="$t('configuratorProductList.noItem')"
      ></p>
    </div>
  </div>
</template>

<script>
import ConfiguratorProductItem from './ConfiguratorProductItem';
import {
  ConfiguratorAction,
  prefixType as prefixConfiguratorType,
  mapState,
} from '../../store/modules/configurator';
import { ThemeType } from '../../api/static/ThemeType';
import ConfiguratorEditorThemePickerButton from './ConfiguratorEditorThemePickerButton';
export default {
  name: 'ConfiguratorProductList',
  emits: ['request-open-theme-picker-modal'],
  components: { ConfiguratorProductItem, ConfiguratorEditorThemePickerButton },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isDocked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      BLOCK_SELECTOR: 'configurator-product-list',
    };
  },
  computed: {
    ...mapState({
      themeType: 'themeType',
    }),
    activeProductId: {
      get() {
        return this.$store.state.configurator.activeProductId;
      },
      set(productId) {
        this.$store.dispatch(
          prefixConfiguratorType(ConfiguratorAction.SET_ACTIVE_STATE),
          { productId, themeType: ThemeType.CUSTOM }
        );
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-product-list {
  $block: &;

  $item-columns: 3;
  $total-parts: 5; // 3 items + 2 button
  $button-parts: 2;
  $gap: 0.5rem;

  &__list-wrapper {
    display: flex;
    flex-direction: column;
    gap: $gap;

    #{$block}--is-docked & {
      flex-direction: row;
    }
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding-left: 0;
    gap: $gap;

    #{$block}--is-docked & {
      flex: 1;
      max-width: 60%;
    }
  }

  &__item {
    // 3 per row in full width
    flex: 0 0 calc((100% - #{($item-columns - 1)} * #{$gap}) / #{$item-columns});
    max-height: 6.5rem;

    #{$block}--is-docked & {
      flex: 1 0
        calc((100% - #{($item-columns - 1)} * #{$gap}) / #{$item-columns});
    }
  }

  &__theme-picker-button-wrapper {
    // full row by default
    flex: 1 0 100%;

    #{$block}--is-docked & {
      flex: unset;
      max-width: 40%;
    }
  }

  &__no-item {
    text-align: center;
    margin-top: 2em;
    margin-bottom: 2em;
    color: $color-gray-dove;

    @include breakpoint($breakpoint-s) {
      margin-left: 25%;
      margin-right: 25%;
    }
  }

  &::v-deep .configurator-product-item__label {
    border-color: $color-arapawa;
  }
}
</style>
